<template>
  <div class="container">
    <page-title title="Carpooling" subtitle="Manage all the carpooling routes in the organization"></page-title>
  </div>
</template>

<script>
import PageTitle from '@/components/PageTitle'
import AnalyticsOverview from '@/components/AnalyticsOverview'

export default {
  components: {
    PageTitle,
    AnalyticsOverview
  },

  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';
</style>
